import { render, staticRenderFns } from "./ModalType.vue?vue&type=template&id=647c4661&scoped=true"
import script from "./ModalType.vue?vue&type=script&lang=js"
export * from "./ModalType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c4661",
  null
  
)

export default component.exports